const React = require("react");
const { createInventorySourceApi } = require("../api/inventorySource.api");

const Context = React.createContext(null);
const ADMIN_ROLES = new Set(["admin", "administrator", "administrateur", "elakay", "family", "familly", "famille"]);

const InventorySourceProvider = ({ baseUrl, token, translate, roleName = "", children }) => {
  const api = React.useMemo(() => createInventorySourceApi({ baseUrl, getToken: () => token }), [baseUrl, token]);
  const t = React.useCallback((key, fallback, values) => translate ? translate(key, fallback, values) : fallback, [translate]);
  const isAdmin = ADMIN_ROLES.has(String(roleName).trim().toLowerCase());
  const value = React.useMemo(() => ({ api, t, isAdmin }), [api, t, isAdmin]);
  return React.createElement(Context.Provider, { value }, children);
};

const useInventorySource = () => {
  const value = React.useContext(Context);
  if (!value) throw new Error("InventorySourceProvider is missing");
  return value;
};

module.exports = { InventorySourceProvider, useInventorySource };
